import React from "react";
import { useNavigate } from "react-router-dom";
import { UserSquare2, ArrowRight } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function AdminCockpitGate() {
  const { t } = useI18n();
  const nav = useNavigate();
  return (
    <div className="fade-in w-full min-h-[60vh] flex items-center justify-center" data-testid="admin-cockpit-gate">
      <div className="max-w-md text-center">
        <div className="w-16 h-16 rounded-2xl bg-[#A3E635]/10 border border-[#A3E635]/25 flex items-center justify-center mx-auto mb-5">
          <UserSquare2 className="w-8 h-8 text-[#A3E635]" />
        </div>
        <h1 className="text-2xl font-black tracking-tight mb-2">{t("Bitte zuerst einen Kunden auswählen.")}</h1>
        <p className="text-sm text-gray-400 mb-7">{t("Das Kunden-Cockpit öffnet den Arbeitsbereich eines einzelnen Kunden. Wählen Sie dazu einen Kunden aus der Übersicht.")}</p>
        <button onClick={() => nav("/admin/clients")} data-testid="admin-cockpit-open-clients"
          className="bg-[#A3E635] hover:bg-[#b6f15a] text-black font-bold py-2.5 px-5 rounded-lg text-sm inline-flex items-center gap-2 transition-colors">
          {t("Kundenübersicht öffnen")} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
